import { LandingNav } from "../components/landing/LandingNav";
import { LandingHero } from "../components/landing/LandingHero";
import { LandingProductTour } from "../components/landing/LandingProductTour";
import { LandingMetrics } from "../components/landing/LandingMetrics";
import { LandingTestimonials } from "../components/landing/LandingTestimonials";
import { LandingFeatures } from "../components/landing/LandingFeatures";
import { LandingPricing } from "../components/landing/LandingPricing";
import { LandingFAQ } from "../components/landing/LandingFAQ";
import { LandingCompare } from "../components/landing/LandingCompare";
import { LandingCtaBand } from "../components/landing/LandingCtaBand";
import { LandingFooter } from "../components/landing/LandingFooter";

export default function Landing() {
  return (
    <div className="min-h-screen bg-white text-zinc-900" data-testid="landing-page">
      <LandingNav />
      <main>
        <LandingHero />
        <LandingProductTour />
        <LandingMetrics />
        <LandingTestimonials />
        <LandingFeatures />
        <LandingPricing />
        <LandingFAQ />
        <LandingCompare />
        <LandingCtaBand />
      </main>
      <LandingFooter />
    </div>
  );
}
